import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { usePermissions } from '@/hooks/usePermissions';
import { UserPermissions } from '@/types/menu';
import { logger } from '@/utils/logger';
import LoadingSpinner from './common/LoadingSpinner';

interface ProtectedRouteProps {
  children: ReactNode;
  permissionRequired?: keyof UserPermissions;
}

const ProtectedRoute = ({ children, permissionRequired }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { hasPermission } = usePermissions();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (permissionRequired && !hasPermission(permissionRequired)) {
    logger.logPermissionDenied(
      user?.email || user?.sub || 'unknown',
      permissionRequired
    );
    return (
      <div className="flex items-center justify-center min-h-screen bg-admin-bg">
        <div className="card max-w-md text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">アクセス権限がありません</h1>
          <p className="text-admin-textLight mb-6">
            この機能にアクセスする権限がありません。
          </p>
          <a href="/" className="btn-primary">
            ダッシュボードに戻る
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
